import styled from 'styled-components';

export const Wrapper = styled.span`
  display: flex;
  justify-content: center;

  width: 100%;

  padding: 20px 5px;
`;
